import { UserInfoI } from "@seneca/user-service-types";

import { Dispatch, GetState } from "common/types";

import { signUpSuccess } from "seneca-common/features/user/state";
import { analyticsLogSignUp } from "seneca-common/utils/senecaAnalytics";

import { saveUserInfo } from "features/user/actions/userInfo";

import { setUserAsSignedUpBefore } from "../../../../utils/signedUpBefore";
import { setRegionPreference } from "../../../preferences";
import { reconcileData } from "../../utils";

type ArgsSignUp = {
  region: string | null | undefined;
  userInfoToSave: Partial<UserInfoI>;
  onSignUpSuccess?: () => void;
};

export default function proceedUserSignUp({
  userInfoToSave,
  region,
  onSignUpSuccess
}: ArgsSignUp) {
  return async function (dispatch: Dispatch, getState: GetState) {
    await dispatch(
      saveUserInfo({
        ...userInfoToSave
      })
    );

    region && dispatch(setRegionPreference(region));

    await dispatch(reconcileData());

    setUserAsSignedUpBefore();

    dispatch(signUpSuccess());

    analyticsLogSignUp(getState());

    onSignUpSuccess && onSignUpSuccess();
  };
}
